import { IUser } from '@boma/client-shared'; // TODO move all shared interfaces into shared... Iuser exists in both @boma/administration-portal/shared/entities and @boma/client-shared causing the circular dependancy
import { ICategory } from './i-category';
import { ICustomer } from './i-customer';
import { IDefinition } from './i-definition';
import { ILocation } from './i-location';
import { IProduct } from './i-product';
import { IBrand } from '@boma/shared/entities';
import { IDepartment } from '@boma/administration-portal/shared/entities';

export interface IFilterSearch {
  query?: string;
  locations?: ILocation[];
  customers?: ICustomer[];
  products?: IProduct[];
  users?: IUser[];
  definitions?: IDefinition[]; // TODO replace all instances of this with definitionFilters
  departments?: IDepartment[];
  categories?: ICategory[];
  brands?: IBrand[];
  definitionsFilters?: {
    targets: number;
    definitionIds: string[];
  };
  selectedDates: { fromDate?: string; toDate?: string; dateString?: string };
}

export interface IFilterBlockOption {
  /// Title above the search block
  title?: string;
  searchPlaceholder?: string;
  definition: boolean;
  options?: any; // use to pass options to the dropdown
}

// Response is IDefinitionsDataResponse
